/**
 *
 * Device
 *
 */

import React from 'react';
import {
  Wrapper,
  ScreenWrapper,
  Wrapper2,
  ScreenWrapper2,
  HomeButton,
  BrowserWrapper,
  ScreenBrowserWrapper,
} from './styledComponents';

import Icon from 'components/Icon';
import { ipad as ipadPreviewSrc } from 'components/DevicePreview';
import { browser as browserPreviewSrc } from 'components/DevicePreview';

const Device = ({ children }) => (
  <Wrapper className='device'>
    <Icon name='device_cam' size={5.28} />
    <ScreenWrapper>
      {children}
    </ScreenWrapper>
    <HomeButton />
  </Wrapper>
);

export const Device2 = ({ children }) => (
  <Wrapper2 className='device' deviceSrc={ipadPreviewSrc}>
    <ScreenWrapper2>
      {children}
    </ScreenWrapper2>
  </Wrapper2>
);

export const Browser = ({ children }) => (
  <BrowserWrapper className='device' deviceSrc={browserPreviewSrc}>
    <ScreenBrowserWrapper>
      {children}
    </ScreenBrowserWrapper>
  </BrowserWrapper>
)

export default Device;



// WEBPACK FOOTER //
// ./src/components/Device/index.js